// eslint-disable-next-line import/prefer-default-export
export const getAdditionalVisitorsTextForBookingSlot = additionalVisitors => {
  let text = '';
  const { length } = additionalVisitors;

  if (length === 1) {
    text += ' with additional visitor ';
  } else if (length > 0) {
    text += ' with additional visitors ';
  }

  additionalVisitors.forEach((visitor, index) => {
    if (index === (length - 1) && length > 1) { // last index
      text += ' and ';
    } else if (index > 0) {
      text += ', ';
    }
    text += `${visitor.firstname} ${visitor.lastname}`;
  });

  return text;
};

export const getKioskItemsText = (kioskItems) => {
  let text = '';

  kioskItems.forEach((item, index) => {
    const last = (index === (kioskItems.length - 1));
    if(index === 0) {
      text += 'The kiosk items paid for are: ';
    }
    if((index > 0) && !last) {
      text += ', ';
    }

    if(last && index > 0) {
      text += ' and ';
    }
    text += `${item.name} (${item.amount})`;

    if(last) {
      text += '.';
    }
  });

  return text;
};
